export const dac_actionType = {
    GET_DAC_SUCCESS : 'GET_DAC_SUCCESS',
    GET_DAC_FAILURE : 'GET_DAC_FAILURE',
    EDIT_REQUEST_START : 'EDIT_REQUEST_START',
    EDIT_REQUEST_SUCCESS : 'EDIT_REQUEST_SUCCESS',
    EDIT_REQUEST_FAILURE : 'EDIT_REQUEST_FAILURE',
    SEARCH_DOCUMENT_LOADER_ON: 'SEARCH_DOCUMENT_LOADER_ON',
    SEARCH_DOCUMENT_LOADER_OFF: 'SEARCH_DOCUMENT_LOADER_OFF',
    SEARCH_VVMC_ROLE_LOADER_ON: 'SEARCH_VVMC_ROLE_LOADER_ON',
    SEARCH_VVMC_ROLE_LOADER_OFF: 'SEARCH_VVMC_ROLE_LOADER_OFF',
    SEARCH_ROLE_ID_SUCCESS: 'SEARCH_ROLE_ID_SUCCESS',
    SEARCH_ROLE_ID_FAILURE: 'SEARCH_ROLE_ID_FAILURE',
    SEARCH_DOC_ID_SUCCESS: 'SEARCH_DOC_ID_SUCCESS',
    SEARCH_DOC_ID_FAILURE: 'SEARCH_DOC_ID_FAILURE',
    RESET_SEARCH_ROLE: 'RESET_SEARCH_ROLE',
    GET_ALL_VVMC_ROLES_SUCCESS: 'GET_ALL_VVMC_ROLES_SUCCESS',
    GET_ALL_VVMC_ROLES_FAILURE: 'GET_ALL_VVMC_ROLES_FAILURE',
    GET_ALL_VVMC_DOC_TYPE_GROUPS_SUCCESS: 'GET_ALL_VVMC_DOC_TYPE_GROUPS_SUCCESS',
    GET_ALL_VVMC_DOC_TYPE_GROUPS_FAILURE: 'GET_ALL_VVMC_DOC_TYPE_GROUPS_FAILURE'
};